import { useCallback, useEffect, useState } from "react";
import RegistrationStepConfirmationComponent from "./RegistrationStepConfirmationComponent";
import RegistrationStepNewComponent from "./RegistrationStepNewComponent";
import RegistrationStepPreRegistrationComponent from "./RegistrationStepPreRegistrationComponent";
import RegistrationStepWaitingListComponent from "./RegistrationStepWaitingListComponent";
import { Tag } from "primereact/tag";
import RegistrationStepDroppoutComponent from "./RegistrationStepDroppoutComponent";

const RegistrationStepsComponent = ({ student, callback, schoolId, trainingId }) => {

    const [currentStudent, setCurrentStudent] = useState();
    useEffect(() => {
        if (student) {
            setCurrentStudent(student);
        }
    }, [student]);

    const doneStep = useCallback((color, latest = false) => {
        if (color === undefined) {
            color = "primary";
        }
        return (
            <>
                <div className={`flex justify-content-center align-items-center border-circle bg-${color}-100 w-4rem h-4rem z-1`}>
                    <i className={`pi pi-check text-xl text-${color}-600`}></i>
                </div>
                {!latest && <div
                    className={`w-full hidden lg:block absolute left-50 bg-${color}-500 hidden`}
                    style={{
                        transform: 'translateY(-50%)',
                        height: '2px',
                        top: '25%'
                    }}></div>}
            </>
        )
    });
    const currentFirstStep = () => (
        <>
            <div className="flex justify-content-center align-items-center border-circle bg-primary-100 w-4rem h-4rem z-1">
                <i className="pi pi-circle-fill text-xl text-primary-600"></i>
            </div>

            <div
                className="w-full hidden lg:block absolute left-50 surface-300 hidden"
                style={{
                    transform: 'translateY(-50%)',
                    height: '2px',
                    top: '25%'
                }}></div>
        </>
    )
    const currentStep = () => (
        <>
            <div className="flex justify-content-center align-items-center border-circle bg-primary-100 w-4rem h-4rem z-1">
                <i className="pi pi-circle-fill text-xl text-primary-600"></i>
            </div>
            <div
                className="w-full hidden lg:block absolute right-50 bg-primary-500 hidden"
                style={{
                    transform: 'translateY(-50%)',
                    height: '2px',
                    top: '25%'
                }}></div>
            <div
                className="w-full hidden lg:block absolute left-50 surface-300 hidden"
                style={{
                    transform: 'translateY(-50%)',
                    height: '2px',
                    top: '25%'
                }}></div>
        </>
    )
    const nextStep = () => (
        <>
            <div
                className="w-full hidden lg:block absolute right-50 surface-300 hidden"
                style={{
                    transform: 'translateY(-50%)',
                    height: '2px',
                    top: '25%'
                }}></div>
            <div className="flex justify-content-center align-items-center surface-200 border-circle  w-4rem h-4rem z-1">
                <i className="pi pi-circle-fill text-xl text-600"></i>
            </div>
        </>
    )


    return (
        <>
            <section className="surface-section px-4 mt-6 md:px-6 lg:px-8">
                <ul className="list-none flex flex-column gap-3 lg:flex-row justify-content-between p-0">
                    <li className="flex align-items-center flex-column gap-3 relative w-full">

                        {(currentStudent?.status === "NEW") && currentFirstStep() || doneStep()}

                        <div className="flex flex-column align-items-center">
                            <h1 className="m-0 font-medium text-900 text-xl line-height-3">Candidature</h1>
                            <span className="text-600 text-base text-center">Origine de la demande</span>
                            {currentStudent?.registration_new ? <Tag severity="warning" value="nouveau" className="ml-2" /> : ""}
                        </div>
                    </li>
                    <li className="flex align-items-center flex-column gap-3 relative w-full">

                        {(currentStudent?.status === "NEW") && nextStep()}
                        {(currentStudent?.status === "PREREGISTRED") && currentStep()}
                        {(currentStudent?.status === "UNREGISTRED") && doneStep("red")}
                        {(currentStudent?.status === "WAITING_LIST") && doneStep("yellow")}
                        {(currentStudent?.status === "ENROLLED") && doneStep()}
                        {(currentStudent?.status === "NEW" || currentStudent?.status === "PREREGISTRED" || currentStudent?.status === "ENROLLED") &&
                            <div className="flex flex-column align-items-center">
                                <h1 className="m-0 font-medium text-900 text-xl line-height-3">Pré-inscription</h1>
                                <span className="text-600 text-base text-center">Dossier à finaliser et signer</span>
                            </div>}
                        {(currentStudent?.status === "WAITING_LIST") &&
                            <div className="flex flex-column align-items-center">
                                <h1 className="m-0 font-medium text-900 text-xl line-height-3">En liste d'attente</h1>
                            </div>}
                        {(currentStudent?.status === "UNREGISTRED") &&
                            <div className="flex flex-column align-items-center">
                                <h1 className="m-0 font-medium text-900 text-xl line-height-3">Désinscrit</h1>
                            </div>}
                    </li>

                    <li className="flex align-items-center flex-column gap-3 relative w-full">

                        {(currentStudent?.status === "ENROLLED") && doneStep("green", true) || nextStep()}

                        < div className="flex flex-column align-items-center">
                            <h1 className="m-0 font-medium text-900 text-xl line-height-3">Confirmation</h1>
                            <span className="text-600 text-base text-center">Et paiement des cotisations</span>
                        </div>
                    </li>
                </ul>
            </section >
            <section className="surface-section px-4 pb-5 md:px-6 lg:px-8">
                <ul className="list-none flex flex-column gap-3 lg:flex-row justify-content-between p-0">
                    <li className="flex align-items-center flex-column gap-3 relative w-full">
                        <RegistrationStepNewComponent currentStudent={currentStudent} setCurrentStudent={setCurrentStudent} callback={callback} schoolId={schoolId} trainingId={trainingId} />
                    </li>
                    <li className="flex align-items-center flex-column gap-3 relative w-full">
                        {currentStudent?.status !== "WAITING_LIST" && <RegistrationStepPreRegistrationComponent currentStudent={currentStudent} setCurrentStudent={setCurrentStudent} callback={() => callback?.()} schoolId={schoolId} trainingId={trainingId} />}
                        {currentStudent?.status === "WAITING_LIST" && <RegistrationStepWaitingListComponent currentStudent={currentStudent} setCurrentStudent={setCurrentStudent} callback={() => callback?.()} schoolId={schoolId} trainingId={trainingId} />}
                        {currentStudent?.status === "UNREGISTRED" && <RegistrationStepDroppoutComponent currentStudent={currentStudent} setCurrentStudent={setCurrentStudent} callback={() => callback?.()} schoolId={schoolId} trainingId={trainingId} />}
                    </li>

                    <li className="flex align-items-center flex-column gap-3 relative w-full">
                        {currentStudent?.status !== "WAITING_LIST" && <RegistrationStepConfirmationComponent currentStudent={currentStudent} setCurrentStudent={setCurrentStudent} callback={() => callback?.()} schoolId={schoolId} trainingId={trainingId} />}
                    </li>
                </ul>
            </section>

        </>
    );
}

export default RegistrationStepsComponent;